import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function PopularComics() {
  const popularComics = comics.filter((c) => c.rating >= 9.5);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-fire-line text-lg text-primary-500"></i>
            </div>
            <h2 className="text-lg md:text-xl font-heading text-foreground-900">热门推荐</h2>
          </div>
          <a href="/category/hot" className="text-sm text-primary-500 hover:text-primary-600 whitespace-nowrap cursor-pointer flex items-center gap-1">
            查看全部
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </a>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {popularComics.map((comic) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              author={comic.author}
              rating={comic.rating}
              status={comic.status}
              updateChapter={comic.updateChapter}
            />
          ))}
        </div>
      </div>
    </section>
  );
}